module.exports = __webpack_public_path__ + "img/img39.38bc812e.svg";